export default "__VITE_PUBLIC_ASSET__398ef63c__"